import { useMemo } from "react";
import { Link } from "react-router-dom";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { CITIES } from "@/data/cities";
import { CITY_COORDS } from "@/data/cityCoords";

export const ZONE_COLORS = {
    dol: "#1B43BD",
    "saint-malo": "#0891B2",
    dinard: "#0D9488",
    dinan: "#D97706",
    emeraude: "#DB2777",
    rennes: "#7C3AED",
    lamballe: "#DC2626",
};

const dotIcon = (color) =>
    L.divIcon({
        className: "zone-dot",
        html: `<span style="display:block;width:12px;height:12px;border-radius:9999px;background:${color};border:2px solid #ffffff;box-shadow:0 1px 4px rgba(10,15,36,0.4)"></span>`,
        iconSize: [12, 12],
        iconAnchor: [6, 6],
    });

const hqIcon = L.divIcon({
    className: "zone-hq",
    html: `<span style="display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:9999px;background:#1B43BD;border:3px solid #ffffff;box-shadow:0 2px 10px rgba(27,67,189,0.5)"><span style="width:8px;height:8px;border-radius:9999px;background:#ffffff"></span></span>`,
    iconSize: [26, 26],
    iconAnchor: [13, 13],
});

const ZoneMap = () => {
    const points = useMemo(
        () => CITIES.filter((c) => CITY_COORDS[c.slug]).map((c) => ({ ...c, coords: CITY_COORDS[c.slug] })),
        []
    );
    const bounds = useMemo(() => L.latLngBounds(points.map((p) => p.coords)).pad(0.08), [points]);
    const icons = useMemo(() => Object.fromEntries(Object.entries(ZONE_COLORS).map(([k, v]) => [k, dotIcon(v)])), []);
    const hq = CITY_COORDS["mont-dol"];

    return (
        <div data-testid="zone-map" className="overflow-hidden rounded-3xl border border-black/10 shadow-[0_20px_60px_rgba(10,15,36,0.12)]">
            <MapContainer
                bounds={bounds}
                scrollWheelZoom={false}
                className="h-[420px] w-full md:h-[540px]"
                style={{ background: "#F3F6FD" }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={hq} icon={hqIcon}>
                    <Popup>
                        <div className="text-sm">
                            <p className="font-bold text-[#1B43BD]">Base Eradikbreizh : Le Mont-Dol</p>
                            <p>Départs d'intervention sous 2h, 7j/7.</p>
                        </div>
                    </Popup>
                </Marker>
                {points.map((c) =>
                    c.slug === "mont-dol" ? null : (
                        <Marker key={c.slug} position={c.coords} icon={icons[c.zone]}>
                            <Popup>
                                <div className="min-w-[170px] text-sm">
                                    <p className="font-bold">{c.name}</p>
                                    <p className="text-slate-500">
                                        {c.dept} · à {c.dist} de la base
                                    </p>
                                    <Link to={`/punaises-de-lit/${c.slug}`} className="mt-1 inline-block font-semibold text-[#1B43BD] underline">
                                        Punaises de lit à {c.name}
                                    </Link>
                                </div>
                            </Popup>
                        </Marker>
                    )
                )}
            </MapContainer>
        </div>
    );
};

export default ZoneMap;
